import React from 'react'
import Helmet from 'react-helmet'

import { FOOD_BOX_PAGE, PageRenderer, useCmsBlock } from '@library/cms-blocks'
import type { CmsFetcher } from '@library/cms-blocks'

import { HowGoustoFoodBoxesWorkTypes } from '../../types'
import { SEO } from '../FoodBoxPage/config'

type Props = HowGoustoFoodBoxesWorkTypes & {
  cmsFetcher: CmsFetcher
}

// startOnboarding stays on the prop signature for parity with FoodBoxPage,
// but the CMS variant uses block-level cta_link fields from ContentStack rather
// than the onboarding handler. Pass-through only.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function FoodBoxCmsPage({ cmsFetcher, startOnboarding: _startOnboarding }: Props) {
  const { data } = useCmsBlock(FOOD_BOX_PAGE, cmsFetcher)

  return (
    <div data-testid="food-box-cms-page">
      <Helmet title={SEO.head.title} meta={SEO.head.meta}>
        <meta property="og:title" content={SEO.head.title} />
        <meta property="og:description" content={SEO.head.meta[0]?.content || ''} />
      </Helmet>
      {data ? <PageRenderer page={data} /> : null}
    </div>
  )
}
